export default "__VITE_ASSET__BufwiGzI__"